export default __webpack_public_path__ + "static/media/logo_accent.20bcf0e6.png";